<app-widget [hideIcon]="true" class="tw-mb-5 tw-block">
  <div class="tw-mb-2 tw-flex tw-flex-wrap tw-items-baseline tw-justify-between tw-gap-2">
    <p class="tw-m-0 tw-text-xl tw-font-semibold tw-text-color-text-default sm:tw-text-lg">
      {{ storageUsage().totalInUsed | number: "1.0-1" }} MB
      <span class="tw-text-sm tw-font-normal tw-text-color-text-tertiary">{{ "used" | i18n }}</span>
    </p>
    <p class="tw-m-0 tw-text-xs tw-text-color-text-tertiary">
      {{ "of" | i18n }}
      <b class="tw-font-medium tw-text-color-text-default">{{
        storageUsage().limit | storageLimit
      }}</b>
      {{ "onThe" | i18n }} {{ currentSubscriptionTier() | capitalise }} {{ "bundle" | i18n }}
    </p>
  </div>

  <div
    class="tw-flex tw-h-3 tw-overflow-hidden tw-rounded-lg tw-bg-color-surface-sunken tw-shadow-elevation-input"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuenow]="totalPct()"
    [attr.aria-valuetext]="
      (storageUsage().totalInUsed | number: '1.0-1') +
      ' MB ' +
      ('used' | i18n) +
      ' — ' +
      ('cabinet' | i18n) +
      ' ' +
      (storageUsage().s3InUsed | number: '1.0-1') +
      ' MB, ' +
      ('accounts' | i18n) +
      ' ' +
      (storageUsage().vaultInUsed | number: '1.0-1') +
      ' MB'
    "
  >
    <div class="tw-h-full tw-bg-dt-custom-teal-11" [style.width.%]="cabinetPct()"></div>
    <div class="tw-h-full tw-bg-dt-indigo-9" [style.width.%]="accountsPct()"></div>
  </div>

  <div class="tw-mt-3 tw-flex tw-flex-wrap tw-gap-5 tw-text-xs tw-text-color-text-secondary">
    <div class="tw-flex tw-items-center tw-gap-1.5">
      <span class="tw-h-2 tw-w-2 tw-rounded-full tw-bg-dt-custom-teal-11"></span>
      {{ "cabinet" | i18n }} — {{ storageUsage().s3InUsed | number: "1.0-1" }} MB
    </div>
    <div class="tw-flex tw-items-center tw-gap-1.5">
      <span class="tw-h-2 tw-w-2 tw-rounded-full tw-bg-dt-indigo-9"></span>
      {{ "accounts" | i18n }} — {{ storageUsage().vaultInUsed | number: "1.0-1" }} MB
    </div>
    <div class="tw-flex tw-items-center tw-gap-1.5">
      <span
        class="tw-h-2 tw-w-2 tw-rounded-full tw-border tw-border-dt-border-secondary tw-bg-color-surface-sunken"
      ></span>
      {{ "free" | i18n }} — {{ freeInUsed() | number: "1.0-1" }} MB
    </div>
  </div>
</app-widget>

<div class="tw-mb-5 tw-grid tw-grid-cols-2 tw-gap-4 sm:tw-grid-cols-1">
  <app-widget [hideIcon]="true" class="tw-block">
    <div class="tw-mb-4 tw-flex tw-items-center tw-gap-3">
      <div
        class="tw-flex tw-h-9 tw-w-9 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-color-accent-today-bg tw-shadow-elevation-control"
      >
        <icon [name]="'cabinet'" [size]="5" [currentColor]="'color-icon-action'"></icon>
      </div>
      <div>
        <h3 class="tw-m-0 tw-text-sm tw-font-semibold tw-text-color-text-default">
          {{ "storageUsedByCabinet" | i18n }}
        </h3>
        <p class="tw-m-0 tw-text-xs tw-text-color-text-tertiary">
          {{ "statementsReceiptsExports" | i18n }}
        </p>
      </div>
    </div>

    <p class="tw-m-0 tw-mb-0.5 tw-text-2xl tw-font-semibold tw-text-color-text-default">
      {{ storageUsage().s3InUsed | number: "1.0-1" }} MB
      <span class="tw-text-xs tw-font-normal tw-text-color-text-tertiary"
        >/ {{ storageUsage().limit | storageLimit }}</span
      >
    </p>
    <p class="tw-m-0 tw-mb-3 tw-text-xs tw-text-color-text-tertiary">
      {{ cabinetPct() | number: "1.0-0" }}% {{ "ofTotalStorage" | i18n }}
    </p>
    <div
      class="tw-mb-3 tw-h-2 tw-overflow-hidden tw-rounded-md tw-bg-color-surface-sunken tw-shadow-elevation-input"
      role="progressbar"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-valuenow]="cabinetPct()"
      [attr.aria-valuetext]="(cabinetPct() | number: '1.0-0') + '% ' + ('ofTotalStorage' | i18n)"
    >
      <div
        class="tw-h-full tw-rounded-md tw-bg-dt-custom-teal-11"
        [style.width.%]="cabinetPct()"
      ></div>
    </div>

    <div
      class="tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-t tw-border-color-border-subtle tw-py-2 tw-text-xs first:tw-border-t-0"
    >
      <div class="tw-flex tw-items-center tw-gap-2 tw-text-color-text-secondary">
        <icon [name]="'receipt'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
        {{ "pdfStatements" | i18n }}
      </div>
      <span class="tw-font-medium tw-text-color-text-default">— MB</span>
    </div>
    <div
      class="tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-t tw-border-color-border-subtle tw-py-2 tw-text-xs first:tw-border-t-0"
    >
      <div class="tw-flex tw-items-center tw-gap-2 tw-text-color-text-secondary">
        <icon [name]="'paperclip'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
        {{ "imagesAndReceipts" | i18n }}
      </div>
      <span class="tw-font-medium tw-text-color-text-default">— MB</span>
    </div>
    <div
      class="tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-t tw-border-color-border-subtle tw-py-2 tw-text-xs first:tw-border-t-0"
    >
      <div class="tw-flex tw-items-center tw-gap-2 tw-text-color-text-secondary">
        <icon [name]="'file-analysis'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
        {{ "csvExports" | i18n }}
      </div>
      <span class="tw-font-medium tw-text-color-text-default">— MB</span>
    </div>

    <app-gloss-button class="tw-mt-3 tw-block" [options]="manageCabinetButton"></app-gloss-button>
  </app-widget>

  <app-widget [hideIcon]="true" class="tw-block">
    <div class="tw-mb-4 tw-flex tw-items-center tw-gap-3">
      <div
        class="tw-flex tw-h-9 tw-w-9 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-bg-color-accent-future-bg tw-shadow-elevation-control"
      >
        <icon [name]="'bank-account'" [size]="5" [currentColor]="'color-accent-future-text'"></icon>
      </div>
      <div>
        <h3 class="tw-m-0 tw-text-sm tw-font-semibold tw-text-color-text-default">
          {{ "storageUsedByAccounts" | i18n }}
        </h3>
        <p class="tw-m-0 tw-text-xs tw-text-color-text-tertiary">
          {{ "fetchedTransactionsAndBalances" | i18n }}
        </p>
      </div>
    </div>

    <p class="tw-m-0 tw-mb-0.5 tw-text-2xl tw-font-semibold tw-text-color-text-default">
      {{ storageUsage().vaultInUsed | number: "1.0-1" }} MB
      <span class="tw-text-xs tw-font-normal tw-text-color-text-tertiary"
        >/ {{ storageUsage().limit | storageLimit }}</span
      >
    </p>
    <p class="tw-m-0 tw-mb-3 tw-text-xs tw-text-color-text-tertiary">
      {{ accountsPct() | number: "1.0-0" }}% {{ "ofTotalStorage" | i18n }}
    </p>
    <div
      class="tw-mb-3 tw-h-2 tw-overflow-hidden tw-rounded-md tw-bg-color-surface-sunken tw-shadow-elevation-input"
      role="progressbar"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-valuenow]="accountsPct()"
      [attr.aria-valuetext]="(accountsPct() | number: '1.0-0') + '% ' + ('ofTotalStorage' | i18n)"
    >
      <div class="tw-h-full tw-rounded-md tw-bg-dt-indigo-9" [style.width.%]="accountsPct()"></div>
    </div>

    <div
      class="tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-t tw-border-color-border-subtle tw-py-2 tw-text-xs first:tw-border-t-0"
    >
      <div class="tw-flex tw-items-center tw-gap-2 tw-text-color-text-secondary">
        <icon [name]="'transactions'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
        {{ "transactionHistory" | i18n }}
      </div>
      <span class="tw-font-medium tw-text-color-text-default">— MB</span>
    </div>
    <div
      class="tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-t tw-border-color-border-subtle tw-py-2 tw-text-xs first:tw-border-t-0"
    >
      <div class="tw-flex tw-items-center tw-gap-2 tw-text-color-text-secondary">
        <icon [name]="'link'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
        {{ "linkedAccountData" | i18n }}
      </div>
      <span class="tw-font-medium tw-text-color-text-default">— MB</span>
    </div>
    <div
      class="tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-t tw-border-color-border-subtle tw-py-2 tw-text-xs first:tw-border-t-0"
    >
      <div class="tw-flex tw-items-center tw-gap-2 tw-text-color-text-secondary">
        <icon [name]="'time'" [size]="4" [currentColor]="'color-text-tertiary'"></icon>
        {{ "fetchSnapshots" | i18n }}
      </div>
      <span class="tw-font-medium tw-text-color-text-default">— MB</span>
    </div>

    <app-gloss-button class="tw-mt-3 tw-block" [options]="manageAccountsButton"></app-gloss-button>
  </app-widget>
</div>

@if (showStorageWarning()) {
  <div
    class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4 tw-rounded-2xl tw-border tw-border-color-status-warning-border tw-bg-color-status-warning-bg tw-px-5 tw-py-4 sm:tw-flex-col sm:tw-items-start"
  >
    <p class="tw-m-0 tw-text-sm tw-text-color-status-warning-text">
      <b class="tw-block tw-text-sm tw-font-semibold tw-text-color-text-default">{{
        "runningLowOnSpace" | i18n
      }}</b>
      {{ "upgradeForMoreStorageMessage" | i18n }}
    </p>
    <app-gloss-button class="sm:tw-w-full" [options]="selectBundleButton"></app-gloss-button>
  </div>
}
